import { render, staticRenderFns } from "./appointmentGoodsList.vue?vue&type=template&id=5ea8cf8c&scoped=true&"
import script from "./appointmentGoodsList.vue?vue&type=script&lang=js&"
export * from "./appointmentGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./appointmentGoodsList.vue?vue&type=style&index=0&id=5ea8cf8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea8cf8c",
  null
  
)

export default component.exports